<template>
  <!-- 数字人列表组件 -->
  <el-card class="generate_ai">
    <el-button type="primary" @click="goBack()">返回</el-button>
    <h3 v-if="type == 1">
      我们支持文字、图片与视频形式的内容输入，能将其统一转化为文字输出。针对生成的文字内容，我们可提供专业的润色服务；同时，若您能提供商品的详细信息或相关关键字，我们也能为您高效生成契合需求的商品文案！
    </h3>
    <h3 v-else-if="type == 2">
      我们可以根据您输入的文字提示词或者上传的产品图片，设计出各种风格的AI产品图供您选择
    </h3>
    <h3 v-else-if="type == 3">
      我们会根据您上传的产品图片或已选定的AI图片，设计出各种风格的产品视频供您选择
    </h3>
    <el-form :inline="true" :model="formVal">
      <el-form-item label="商品ID：">
        <el-input
          v-model.trim="formVal.productId"
          class="input-width"
          placeholder="请输入商品ID"
          @blur="handleProductIdBlur"
        />
      </el-form-item>

      <el-form-item label="商品名称：">
        <el-select
          v-model="searchProductId"
          filterable
          remote
          reserve-keyword
          placeholder="请选择或输入商品名称"
          :remote-method="remoteMethod"
          :loading="productNameLoading"
          @change="handleProductNameChange"
        >
          <el-option
            v-for="item in productNameList"
            :key="item.id"
            :label="item.productName"
            :value="item.productId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="Search" @click="queryGoods()"
          >查询</el-button
        >
        <el-button icon="Refresh" @click="reset()">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="img_upload">
      <div>
        <p class="mb-2">上传产品图:</p>
        <uploadAudioVue
          @success="formVal.imageUrl = $event"
          :value.sync="formVal.imageUrl"
          ref="uploadAudioRef"
        />
      </div>
      <div class="upload_video" v-if="type == 1">
        <p class="mb-2">上传产品视频:</p>
        <uploadVideoVue
          @success="handleUploadAudioSuccess"
          :value="{ url: formVal.urls }"
          ref="uploadVideoRef"
        />
      </div>
      <div class="tip">
        <p class="mb-2">输入提示词:</p>
        <div class="tip_txt">
          <el-input
            v-model="formVal.text"
            class="tip_ipt"
            resize="none"
            placeholder="想让AI更好地理解您的创意吗？请告诉我们您的构想：
       身在何处？（环境场景） 
       主角是什么？（商品主体）
       想要什么感觉？（风格调性）
       请用500字以内的关键词描述吧，尽情发挥您的想象力！"
            type="textarea"
            :rows="14"
            maxlength="500"
            show-word-limit
          ></el-input>
          <el-button
            type="warning"
            v-if="type == 2 || type == 3"
            class="tip_color"
            @click="aiCopyWriting(0)"
          >
            智能文本润色
          </el-button>
          <el-button
            type="success"
            @click="$refs.tipTemplateRef.open()"
            class="tip_template"
          >
            提示词模版
          </el-button>
        </div>
      </div>
    </div>
    <div v-if="type == 3" class="video-condition">
      <div>
        <span>视频品质：</span>
        <el-select
          v-model="formVal.mode"
          placeholder="请选择视频品质"
          style="width: 150px"
        >
          <el-option label="标准模式(标准)" value="std"></el-option>
          <el-option label="专家模式(高品质)" value="pro"></el-option>
        </el-select>
      </div>
      <div>
        <span>视频时长：</span>
        <el-select
          v-model="formVal.duration"
          placeholder="请选择视频时长"
          style="width: 150px"
          clearable
        >
          <el-option label="5秒" value="5"></el-option>
          <el-option label="10秒" value="10"></el-option>
        </el-select>
      </div>
      <div>
        <span>视频个数：</span>
        <el-select
          v-model="formVal.count"
          placeholder="请选择视频个数"
          style="width: 150px"
          clearable
        >
          <el-option label="1" :value="1"></el-option>
          <el-option label="2" :value="2"></el-option>
          <el-option label="3" :value="3"></el-option>
          <el-option label="4" :value="4"></el-option>
          <el-option label="5" :value="5"></el-option>
        </el-select>
      </div>
      <div>
        <span>首尾帧：</span>
        <el-switch v-model="formVal.imageTailUrl"> </el-switch>
      </div>
    </div>
    <el-button
      size="big"
      type="primary"
      :loading="loading"
      :disabled="loading"
      @click="aiWriting"
      >AI{{ typeText }}生成</el-button
    ><span v-if="loading" class="wait">AI生成中... ... 请勿刷新页面!</span>

    <!-- 文案列表 -->
    <div v-if="type == 1">
      <div class="tip" v-for="(item, idx) in currentPageData" :key="idx">
        <el-input
          ref="textareaRef"
          v-model="item.val"
          class="audioText"
          placeholder="AI文案"
          type="textarea"
          :rows="8"
          maxlength="1000"
          :disabled="item.disabled"
        ></el-input>
        <el-button type="warning" class="tip_color" @click="editText(idx)">
          编辑文本
        </el-button>
        <el-button
          type="success"
          class="tip_template"
          @click="handleSelect(item)"
        >
          使用文案
        </el-button>
      </div>
      <el-empty
        v-if="!textList.length"
        :description="`暂无AI${typeText}`"
      ></el-empty>
      <!-- 分页控制器 -->
      <div class="pagination-controls">
        <button
          @click="prevPage"
          :disabled="currentPage === 1"
          class="page-btn"
        >
          上一页
        </button>

        <span class="page-info">
          第 {{ currentPage }} 页 / 共 {{ totalPages }} 页
        </span>

        <button
          @click="nextPage"
          :disabled="currentPage === totalPages"
          class="page-btn"
        >
          下一页
        </button>

        <select
          v-model="pageSize"
          @change="resetPagination"
          class="page-size-select"
        >
          <option value="3">3条/页</option>
          <option value="6">6条/页</option>
          <option value="9">9条/页</option>
        </select>
      </div>
    </div>
    <!-- 产品图列表 -->
    <div v-if="type == 2" class="img_list">
      <el-empty
        v-if="!allImages.length"
        :description="`暂无AI${typeText}`"
      ></el-empty>
      <changeImageVue
        :allImages="allImages"
        :type="typeText"
        :formVal="formVal"
      ></changeImageVue>
    </div>
    <!-- 视频列表 -->
    <div v-if="type == 3" class="img_list">
      <el-empty
        v-if="!allImages.length"
        :description="`暂无AI${typeText}`"
      ></el-empty>
      <changeImageVue
        :allImages="allImages"
        :type="typeText"
        :formVal="formVal"
      ></changeImageVue>
    </div>
    <tipTemplateVue ref="tipTemplateRef" :type="type"></tipTemplateVue>
  </el-card>
</template>

<script>
import {
  reqAiCopyWriting,
  reqAiImageWriting,
  reqAiVideoWriting,
  reqGoodsDetail,
  reqAiImageWritingResult,
  reqAiVideoWritingResult,
  reqSetGoods,
} from "@/assets/api/aiProduct";
import uploadAudioVue from "./components/uploadImage.vue";
import uploadVideoVue from "./components/uploadAudio.vue";
import aiDesignVue from "./components/aiDesign.vue";
import changeImageVue from "./components/changeImage.vue";
import tipTemplateVue from "./components/tipTemplate.vue";
import { EventSourcePolyfill } from "event-source-polyfill";
import { Typewriter } from "./typeriter.js";

export default {
  components: {
    uploadAudioVue,
    uploadVideoVue,
    aiDesignVue,
    changeImageVue,
    tipTemplateVue,
  },
  data() {
    return {
      searchProductId: "",
      productNameLoading: false,
      eventSource: null,
      loading: false,
      textList: [],
      list: [],
      allImages: [],
      aiVideoTimer: [],
      formVal: {
        imageUrl: "",
        text: "",
        productId: "",
        productName: "",
        urls: "",
        duration: "5",
        count: 2,
        mode: "std",
        imageTailUrl: false,
      },
      type: this.$route.query.type,
      timer: null,
      currentPage: 1,
      pageSize: 3,
      connectionStatus: "未连接",
      typewriter: null,
      txtValue: "",
      productNameList: [],
    };
  },

  mounted() {
    this.formVal.productName = this.$route.query.productName;

    if (this.$route.query.productId) {
      this.formVal.imageUrl = this.$route.query.imageUrl;
      this.formVal.productId = this.$route.query.productId;
      this.$refs.uploadAudioRef.search(this.$route.query.imageUrl);
      if (this.$route.query.text) {
        this.formVal.text = this.$route.query.text;
      } else {
        this.queryGoods();
      }
    }
    if (this.$route.query.productId && this.$route.query.productName) {
      this.searchProductId = this.$route.query.productId;
      this.productNameList = [
        {
          productName: this.$route.query.productName,
          productId: this.$route.query.productId,
        },
      ];
    }
    if (this.$route.query.imageToVideoQuick) {
      this.formVal.count = 1;
      this.formVal.duration = "10";
      this.formVal.mode = "pro";
      this.aiWriting();
    }
  },
  watch: {
    $route(val) {
      this.formVal.productName = val.query.productName;

      if (val.query.productId) {
        this.formVal.imageUrl = val.query.imageUrl;
        this.formVal.productId = val.query.productId;
        this.$refs.uploadAudioRef.search(val.query.imageUrl);
        if (val.query.text) {
          this.formVal.text = val.query.text;
        } else {
          this.queryGoods();
        }
      }
      if (val.query.productId && val.query.productName) {
        this.searchProductId = val.query.productId;
        this.productNameList = [
          {
            productName: val.query.productName,
            productId: val.query.productId,
          },
        ];
      }
      if (val.query.imageToVideoQuick) {
        this.formVal.count = 1;
        this.formVal.duration = "10";
        this.formVal.mode = "pro";
        this.aiWriting();
      }
    },
  },
  destroyed() {
    clearInterval(this.timer);
    this.aiVideoTimer.forEach(function (timer) {
      clearInterval(timer);
    });
    this.aiVideoTimer = [];
    // 关闭已有连接
  },
  // beforeDestroy() {
  //   this.closeSSE();
  // },
  computed: {
    typeText() {
      if (this.type == 1) {
        return "文案";
      } else if (this.type == 2) {
        return "产品图";
      } else {
        return "视频";
      }
    },
    totalPages() {
      return Math.ceil(this.textList.length / this.pageSize);
    },
    currentPageData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + parseInt(this.pageSize);
      return this.textList.slice(start, end);
    },
  },
  methods: {
    /**
     * 上传音频成功
     */
    handleUploadAudioSuccess(data) {
      this.formVal.urls = data.url;
    },
    // ai生产
    aiWriting() {
      if (!this.formVal.text) {
        this.$message.error("请输入提示词");
        return;
      }
      if (this.type == 1) {
        this.aiCopyWriting(1);
      } else if (this.type == 2) {
        this.aiImageWriting();
      } else {
        this.aiVideoWriting();
      }
    },
    async handleSelect(row) {
      const res = await reqSetGoods({
        aiProductResultId: row.id,
        aiText: row.val,
      });
      if (res.code == 200) {
        this.$message.success(res.message);
      } else {
        this.$message.warning(res.message);
      }
    },
    // AI文字生成
    async aiCopyWriting(way) {
      this.loading = true;
      let type;
      if (this.formVal.urls) {
        if (this.formVal.urls && this.formVal.imageUrl) {
          type = 2;
        } else {
          type = 3;
        }
      } else if (way == 1) {
        if (!this.formVal.urls && !this.formVal.imageUrl) {
          type = 1;
        } else {
          type = 2;
        }
      } else if (way == 0) {
        type = 1;
      }
      this.connectSSE(way, type);
    },
    // AI图片生成
    async aiImageWriting() {
      this.loading = true;
      const res = await reqAiImageWriting({
        text: this.formVal.text,
        productId: this.formVal.productId,
        productName: this.formVal.productName,
        imageCount: 2,
        imageUrl: this.formVal.imageUrl,
        aspectRatio: "1:1",
      });
      if (res.code == 200) {
        const taskId = res.data;
        this.timer = setInterval(async () => {
          const result = await reqAiImageWritingResult({ taskId });
          if (result.code == 200) {
            this.$message.success("生成成功!");
            this.allImages.unshift(
              ...result.data.map((item) => {
                return {
                  url: item.aiContent,
                  id: item.id,
                  aiContent: item.aiContent,
                };
              })
            );
            this.loading = false;
            clearInterval(this.timer);
          } else {
            this.$message.warning("AI生成中 请耐心等待!");
          }
        }, 5000);
      } else {
        this.$message.warning(res.message);
        this.loading = false;
      }
    },
    // AI 视频生成
    async aiVideoWriting() {
      this.loading = true;
      try {
        const res = await reqAiVideoWriting({
          text: this.formVal.text,
          productId: this.formVal.productId,
          productName: this.formVal.productName,
          imageUrl: this.formVal.imageUrl,
          mode: this.formVal.mode,
          duration: this.formVal.duration,
          count: this.formVal.count,
          imageTailUrl: this.formVal.imageTailUrl
            ? this.formVal.imageUrl
            : undefined,
        });

        if (res.code == 200) {
          const taskIds = res.data; // taskId 是一个字符串数组
          this.pollVideoTasks(taskIds); // 开始轮询所有 taskId
        } else {
          this.$message.warning(res.message);
          this.loading = false;
        }
      } catch (error) {
        this.$message.error("视频生成请求失败: " + error.message);
        this.loading = false;
      }
    },

    // 并发轮询所有 taskId，收集成功结果
    async pollVideoTasks(taskIds) {
      this.loading = true;
      const successfulResults = [];

      // 并发启动所有任务的轮询
      const pollPromises = taskIds.map((taskId) =>
        this.pollSingleTask(taskId)
          .then((result) => {
            // 成功的结果存入 successfulResults
            if (result.code == 200) {
              successfulResults.push(
                ...result.data.map((item) => ({
                  url: item.aiContent,
                  id: item.id,
                  aiContent: item.aiContent,
                }))
              );
            }
          })
          .catch((error) => {
            // 失败的任务只提示错误，不抛出异常
            this.$message.error(`任务 ${taskId} 生成失败: ${error.message}`);
          })
      );

      // 等待所有轮询任务完成（无论成功或失败）
      await Promise.allSettled(pollPromises);

      // 处理成功的结果
      if (successfulResults.length > 0) {
        this.allImages.unshift(...successfulResults);
        this.$message.success(`成功生成 ${successfulResults.length} 个视频!`);
      } else {
        this.$message.warning("没有任务成功生成视频");
      }

      this.loading = false;
    },

    // 轮询单个 taskId
    pollSingleTask(taskId) {
      return new Promise((resolve, reject) => {
        const interval = setInterval(async () => {
          try {
            const result = await reqAiVideoWritingResult({ taskId });
            if (result.code == 200) {
              clearInterval(interval); // 任务完成，停止轮询
              resolve(result); // 返回结果
            } else {
              this.$message.warning(`任务 ${taskId} 生成中，请耐心等待!`);
            }
          } catch (error) {
            clearInterval(interval); // 出错时停止轮询
            this.aiVideoTimer = this.aiVideoTimer.filter((t) => t !== interval);
            reject(error); // 抛出错误
          }
        }, 5000); // 每 5 秒轮询一次
        this.aiVideoTimer.push(interval);
      });
    },
    editText(idx) {
      this.textList[idx].disabled = false;
    },
    reset() {
      this.formVal.productId = "";
      this.formVal.productName = "";
      this.$refs.uploadAudioRef.handleRemove();
    },
    /**
     * 获取商品数据
     */
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    resetPagination() {
      this.currentPage = 1;
    },
    remoteMethod(query) {
      if (query !== "") {
        this.productNameLoading = true;
        reqGoodsDetail({
          productName: query,
          generateType: this.type,
        }).then((res) => {
          if (res.code == 200) {
            this.productNameList = res.data;
            this.productNameLoading = false;
          }
        });
      } else {
        this.productNameList = [];
      }
    },
    handleProductNameChange(val) {
      this.formVal.productId = val;
      this.formVal.productName = this.productNameList.find(
        (item) => item.productId === val
      ).productName;
    },
    handleProductIdBlur(e) {
      const id = e.target.value;
      this.formVal.productName = "";
      if (id) {
        this.productNameLoading = false;
        this.queryGoodsById();
      }
    },
    queryGoodsById() {
      reqGoodsDetail({
        productId: this.formVal.productId,
        generateType: this.type,
      }).then((res) => {
        if (res.code == 200) {
          this.productNameList = res.data;
          if (res.data.length <= 1) {
            this.formVal.productName = res.data[0].productName;
            this.searchProductId = res.data[0].productId;
          }
        } else {
          this.formVal.productName = "";
          this.productNameList = [];
          this.searchProductId = "";
        }
      });
    },
    // 查询商品信息
    async queryGoods() {
      const res = await reqGoodsDetail({
        productId: this.formVal.productId,
        productName: this.formVal.productName,
        generateType: this.type,
      });
      if (res.code == 200) {
        // 存在记录
        if (res.data.length && res.data[0].existRecord) {
          this.formVal.imageUrl = res.data[0].imageUrl;
          this.$refs.uploadAudioRef.search(res.data[0].imageUrl);
          this.formVal.text = res.data[0].prompt;
          this.$message.success("搜索成功,已自动恢复到上次生成记录!");
        } else {
          this.$message.success("该商品暂无生成记录");
        }
      } else {
        this.formVal = {
          imageUrl: "",
          text: "",
          productId: this.formVal.productId,
          productName: this.formVal.productName,
          urls: "",
          duration: "5",
          count: 2,
          mode: "std",
        };
        this.searchProductId = "";
        this.$message.warning(res.message);
      }
    },
    connectSSE(way, type) {
      this.textList.unshift({
        val: "",
        id: "",
        disabled: true,
      });
      this.closeSSE();

      const params = new URLSearchParams({
        type,
        text: this.formVal.text,
        productId: this.formVal.productId,
        productName: this.formVal.productName,
        urls: this.formVal.imageUrl || this.formVal.urls,
      });
      const url =
        process.env.VUE_APP_API +
        `/aistream/api/merchant/product/ai-text-stream/add?${params.toString()}`;

      this.eventSource = new EventSourcePolyfill(url, {
        headers: {
          Authorization: localStorage.getItem("token"),
          withCredentials: true,
        },
      });

      this.eventSource.onopen = (e) => {
        this.connectionStatus = "已连接";
        // console.log("SSE连接已建立", e);
      };
      if (way == 0) {
        this.formVal.text = "";
      }
      this.eventSource.onmessage = (e) => {
        this.txtValue += JSON.parse(e.data).message;
        if (way == 1) {
          this.textList[0].val += JSON.parse(e.data).message;
        } else {
          this.formVal.text += JSON.parse(e.data).message;
        }
        if (JSON.parse(e.data).aiProductResult) {
          this.textList[0].id = JSON.parse(e.data).aiProductResult.id;
          this.loading = false;
          this.closeSSE();
        }
      };

      this.eventSource.onerror = (e) => {
        this.loading = false;

        if (e.readyState === EventSource.CLOSED) {
          this.connectionStatus = "连接已关闭";
        } else {
          this.connectionStatus = "连接异常";
        }
      };
    },
    processGPTResponse(data) {
      // 4. 逐字渲染实现
      if (!this.typewriter) {
        this.typewriter = new Typewriter(this.$refs.textareaRef, {
          speed: 50, // 控制打字速度(ms/字符)
          onComplete: () => {
            this.scrollToBottom();
          },
        });
      }

      // 5. 处理GPT流式数据
      if (data) {
        const char = this.typewriter.add(data);
      }
    },
    goBack() {
      // this.$router.replace("createAi");
      this.$router.go(-1);
    },
    scrollToBottom() {
      this.$nextTick(() => {
        this.$refs.textareaRef.scrollTop = this.$refs.textareaRef.scrollHeight;
      });
    },
    closeSSE() {
      console.log("closeSSE");
      if (this.eventSource) {
        this.eventSource.close();
        this.eventSource = null;
        this.connectionStatus = "已断开";
      }
    },
  },
};
</script>

<style scoped lang="scss">
h3 {
  margin: 20px 0;
}

.img_upload {
  display: flex;
  margin-bottom: 20px;
  .tip {
    margin: 0;
    margin-left: 50px;
    width: 800px;
  }
}

.tip {
  margin: 20px 0;
  .tip_txt {
    height: 375px;
    overflow: auto;
    border: 1px solid #dcdfe6;
    position: relative;
  }
  .tip_ipt {
  }
  .tip_template {
    position: absolute;
    bottom: 16px;
    right: 16px;
  }
  .tip_color {
    position: absolute;
    bottom: 16px;
    right: 136px;
  }
}
.img_list {
  // display: flex;
  margin: 20px 20px 20px 0;
  width: 100%;
}
.next {
  width: 120px;
  height: 40px;
}
.img_item {
  position: relative;
  width: 400px;
  height: 280px;
  margin-right: 20px;
  margin-bottom: 20px;
  .mask {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    &:nth-child(2) {
      height: 25%;
      top: 35%;
    }
  }
  .tip_template {
    position: absolute;
    bottom: -20px;
    right: 0;
  }
  .tip_color {
    position: absolute;
    bottom: -20px;
    right: 120px;
  }
  .select {
    display: none;
    position: absolute;
    top: 140px;
    left: 150px;
    z-index: 9;
  }
}
.img_item:hover .mask,
.img_item:hover .select {
  display: flex;
}
.upload_video {
  margin-left: 20px;

  p {
    margin-bottom: 300px;
  }
}
.video-content {
  width: 400px;
  height: 300px;
}
.wait {
  color: #999;
  margin-left: 20px;
}
.pagination-wrapper {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
}

.data-list {
  margin-bottom: 20px;
  border: 1px solid #eee;
  border-radius: 4px;
  overflow: hidden;
}

.data-item {
  padding: 12px 15px;
  border-bottom: 1px solid #eee;
  transition: background 0.3s;
}

.data-item:hover {
  background: #f5f5f5;
}

.pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.page-btn {
  padding: 8px 16px;
  background: #42b983;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: opacity 0.3s;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 14px;
  color: #666;
}

.page-size-select {
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ddd;
}
.mb-2 {
  margin-bottom: 8px;
}

.video-condition {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}
::v-deep .el-textarea__inner {
  border: none;
}
</style>
